import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import _ from 'lodash'

import core from './core'
import users from './users'
import register from './register'
import centre from './centre'
import personnel from './personnel'
// import dashboard from './dashboard'

const { Auth, Logout, Login, NoMatch } = core.components

const Router = props => {
  const Header = props.header
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/logout"
          render={routeProps => <Logout {...props} {...routeProps} />}
        />
        <Route
          exact
          path="/login"
          render={routeProps => <Login {...props} {...routeProps} />}
        />
        <Route
          path="/"
          render={routeProps => {
            const { location: { pathname } } = routeProps
            return (
              <Header
                tabs={
                  _.includes(pathname, '/register')
                    ? register.constants.subForms
                    : _.includes(pathname, '/personnel')
                      ? personnel.constants.subForms
                      : _.includes(pathname, '/centres')
                        ? centre.constants.subForms
                        : [
                            {
                              id: 1,
                              label: `/${pathname}/`.split('/').join(''),
                              path: `${pathname}`
                            }
                          ]
                }
                {...props}
                {...routeProps}
              />
            )
          }}
        />
      </Switch>
      <Switch>
        <Route
          exact
          path="/"
          render={routeProps => <Redirect to={'/register'} />}
        />
        {/*
        <Route
          exact
          path="/dashboard"
          render={routeProps => (
            <Auth app>
              <dashboard.components.Dashboard {...props} {...routeProps} />
            </Auth>
          )}
        /> */}
        {/* <Route
        exact
        path="/"
        render={routeProps =>
          <core.components.UnderConstruction {...props} {...routeProps} />}
      /> */}

        <Route
          exact
          path={`${users.constants.PATH}:id`}
          render={routeProps => (
            <Auth route>
              <users.components.Detail {...props} {...routeProps} />
            </Auth>
          )}
        />
        <Route
          path={`${users.constants.PATH}`}
          render={routeProps => (
            <Auth route>
              <users.components.Container {...props} {...routeProps} />
            </Auth>
          )}
        />
        <Route
          exact
          path={`${users.constants.PROFILE_PATH}`}
          render={routeProps => (
            <Auth app>
              <core.components.UnderConstruction {...props} />
              {/*} <users.components.Profile {...props} {...routeProps} />*/}
            </Auth>
          )}
        />
        <Route
          path={`${register.constants.PATH}`}
          render={routeProps => (
            <Auth app>
              <register.components.Container {...props} {...routeProps} />
            </Auth>
          )}
        />

        <Route
          path={`${personnel.constants.PATH}`}
          render={routeProps => (
            <Auth route>
              <personnel.components.Container {...props} {...routeProps} />
              {/* <core.components.UnderConstruction {...props} {...routeProps} /> */}
            </Auth>
          )}
        />

        <Route
          path={`${centre.constants.PATH}`}
          render={routeProps => (
            <Auth route>
              <centre.components.Container {...props} {...routeProps} />
            </Auth>
          )}
        />

        <Route
          render={routeProps => (
            <Auth app>
              <div
                style={{
                  marginTop: 70,
                  padding: 10
                }}
              >
                <NoMatch {...props} {...routeProps} />
              </div>
            </Auth>
          )}
        />
      </Switch>
    </div>
  )
}

export default Router



// WEBPACK FOOTER //
// ./src/Router.js